<kt-portlet>
  <kt-portlet-header [class]="'card-head-lg'" style="box-shadow: unset">
    <ng-container ktPortletTitle>
      <span>{{ companyNotification.description }}</span>
    </ng-container>
    <ng-container ktPortletTools> </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <form class="form" [formGroup]="companyNotificationForm">
      <div class="row">
        <div class="col-lg-6">
          <h5>Enable Notification</h5>
        </div>
        <div class="col-lg-6">
          <div class="mat-form-field-fluid">
            <mat-slide-toggle
              class="mr-2"
              (change)="updateNotification()"
              formControlName="is_active"
            ></mat-slide-toggle>
          </div>
        </div>
        <div class="col-lg-6" style="padding-top: 15px" [hidden]="data.level === 'USER'">
          <h5>Configurable</h5>
        </div>
        <div class="col-lg-6" style="padding-top: 15px" [hidden]="data.level === 'USER'">
          <div class="mat-form-field-fluid">
            <mat-slide-toggle
              class="mr-2"
              (change)="updateNotification()"
              formControlName="is_configurable"
            ></mat-slide-toggle>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="companyNotification.channels.length > 0" style="margin-top: 30px">
      <div style="margin-top: 15px">
        <h5>Enabled Channels</h5>
      </div>
      <div *ngFor="let channel of companyNotification.channels">
        <kt-channel-control
          [related_id]="data.related_id"
          [level]="data.level"
          [notification_id]="companyNotification.id"
          [channel]="channel"
        ></kt-channel-control>
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="d-flex justify-content-end">
      <div class="mr-2"></div>
      <div>
        <button
          type="button"
          mat-raised-button
          [mat-dialog-close]="data.animal"
          cdkFocusInitial
          matTooltip="Cancel changes"
        >
          <span>Close</span></button
        >&nbsp;
      </div>
    </div>
  </kt-portlet-footer>
</kt-portlet>
